import React, { Fragment } from 'react'
import MonthView from 'modules/Drives/CalendarView/Partials/MonthView'
import WeekView from 'modules/Drives/CalendarView/Partials/WeekView'

const CalendarView = ({ monthView, drivesList }) => {
  return (
    <Fragment>
      {monthView ? <MonthView drivesList={drivesList} fullscreen={true} /> : <WeekView listOfDrives={drivesList}/>}
    </Fragment>
  )
}

export default CalendarView
